import {
  createCorrection,
  deleteCorrection,
  listCorrectionId,
  listCorrections,
  updateCorrection,
} from './Correction.services';
import { useMutation, useQuery } from 'react-query';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';

export function useCorrections(invoiceId: number) {
  return useQuery(['corrections'], () => listCorrections(invoiceId), {
    onError(error) {
      notificationError(error);
    },
  });
}

export function useCorrectionId(invoiceId: number, cceId: number) {
  return useQuery(
    ['corrections', cceId],
    () => listCorrectionId(invoiceId, cceId),
    {
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useCreateCorrection() {
  return useMutation(createCorrection, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Carta de correção criada',
      });

      queryClient.invalidateQueries(['corrections']);
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useUpdateCorrection() {
  return useMutation(updateCorrection, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Carta de correção editada',
      });

      queryClient.invalidateQueries(['corrections']);
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useDeleteCorrection() {
  return useMutation(
    ({ invoiceId, cceId }: { invoiceId: number; cceId: number }) =>
      deleteCorrection(invoiceId, cceId),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso',
          description: 'Carta de correção deletada',
        });

        queryClient.invalidateQueries(['corrections']);
      },
      onError(error) {
        notificationError(error);
      },
    },
  );
}
